import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { ActionResult, ActionResultList, CategoryItem, CompetitorFilter, CompetitorResults, PagedFilter } from "@model";
import { EnvironmentService } from "./environment.service";

@Injectable({ providedIn: 'root' })
export class CompetitorResultsService {

  constructor(private http: HttpClient, private environmentService: EnvironmentService) {}

  getCompetitorResults(filter: PagedFilter<CompetitorFilter>, isAdmin:boolean = false, getAll: boolean = false): Observable<CompetitorResults[]> {
    if (isAdmin) {
      return this.http.post<ActionResultList<CompetitorResults[], number>>(
        this.environmentService.getApiUrl() + "/api/competitors/results", filter
      ).pipe(map(value => value?.result?.length ? value.result : []));
    }
    return this.http.post<ActionResultList<CompetitorResults[], number>>(
      this.environmentService.getApiUrl() + `/api/public/competitors/results?all=${getAll}`, filter
    ).pipe(map(value => {
      return  value?.result?.length ? value.result : []
    }));
  }

  findCategoryItemsByRaceId(raceId: number): Observable<CategoryItem[]> {
    return this.http.get<ActionResult<CategoryItem[]>>(
      this.environmentService.getApiUrl() + `/api/public/category/race/${raceId}`
    ).pipe(map(value => value?.result?.length ? value.result : []));
  }

  findCategoryItemsByEventId(eventId: number): Observable<CategoryItem[]> {
    return this.http.get<ActionResult<CategoryItem[]>>(
      this.environmentService.getApiUrl() + `/api/public/category/event/${eventId}`
    ).pipe(map(value => value?.result?.length ? value.result : []));
  }
}
